<template>
	<div class="permission-manage">
		<Title title="帳號與權限管理"></Title>
		<div class="feature">
			<el-button type="primary" @click="openDialog()">新增帳號</el-button>
		</div>
		<el-table :data="accountList" fit :default-sort="{prop: 'date', order: 'descending'}">
			<el-table-column label="身份">
				<template slot-scope="scope">{{mapRole(scope.row.role)}}</template>
			</el-table-column>
			<el-table-column label="組別" prop="group" />
			<el-table-column label="姓名" prop="name" />
			<el-table-column label="操作">
				<template slot-scope="scope">
					<div class="row" gutter="20">
						<el-button type="text" @click="openDialog(scope.row)">修改</el-button>
						<el-button type="text" class="color-danger" icon="el-icon-delete" circle @click="handleDelete(scope.row.id)" />
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- 跳窗 -->
		<el-dialog :title="(isNewAccount)? '新增帳號':'帳號設定'" :visible.sync="dialogVisible" @close="resetForm()">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
				<el-form-item label="身份" prop="role">
					<el-select v-model="ruleForm.role" placeholder="選擇身份" @change="handleChangeRole">
						<el-option v-for="(item, i) in roleList" :key="i" :label="item.label" :value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="組別" prop="group">
					<el-select v-model="ruleForm.group" placeholder="選擇組別">
						<el-option v-for="(item, i) in groupList" :key="i" :label="item" :value="item" />
					</el-select>
				</el-form-item>
				<el-form-item label="姓名" prop="name">
					<el-input v-model="ruleForm.name" placeholder="輸入姓名" />
				</el-form-item>
				<el-form-item label="帳號" prop="account">
					<el-input v-model="ruleForm.account" placeholder="輸入帳號" />
				</el-form-item>
				<el-form-item label="密碼" prop="password">
					<el-input v-model="ruleForm.password" placeholder="輸入密碼" />
				</el-form-item>
				<el-form-item label="權限內容"></el-form-item>
				<el-form-item label="官網" prop="official_routes">
					<el-select v-model="ruleForm.official_routes" multiple placeholder="選擇權限">
						<el-option v-for="(item, i) in officialRouteOptions" :key="i" :label="item.label" :value="item" />
					</el-select>
				</el-form-item>
				<el-form-item label="挑戰平台" prop="challenge_routes">
					<el-select v-model="ruleForm.challenge_routes" multiple placeholder="選擇權限">
						<el-option v-for="(item, i) in challengeRouteOptions" :key="i" :label="item.label" :value="item" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<div class="row" align-x="right">
						<el-button type="info" @click="closeDialog">取消</el-button>
						<el-button v-if="isNewAccount" @click="handleNew()" type="success">新增</el-button>
						<el-button v-else @click="handleUpdate()" type="success">儲存</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import { mapActions, mapState } from "vuex";
import _ from "lodash";

function fields() {
	return {
		role: '',
		group: '',
		name: '',
		account: '',
		password: '',
		official_routes: [],
		challenge_routes: []
	}
}
export default {
	components: { Title },
	data() {
		return {
			dialogVisible: false,
			isNewAccount: false,	// 是否創立新帳號
			ruleForm: fields(),
			rules: {
				role: [{ required: true, trigger: 'blur', message: '角色' }],
				name: [{ required: true, trigger: 'blur', message: '姓名' }],
				group: [{ required: true, trigger: 'blur', message: '組別' }],
				account: [{ required: true, trigger: 'blur', message: '帳號' }],
				password: [{ required: true, trigger: 'blur', message: '密碼' }]
			}
		};
	},
	computed: {
		...mapState('user', ['userInfo']),
		...mapState('manager', ['roleList', 'groupList', 'accountList', 'challengeRoutes', 'officialRoutes']),
		officialRouteOptions() {
			return this.mapRouteListOptions(this.officialRoutes);
		},
		challengeRouteOptions() {
			return this.mapRouteListOptions(this.challengeRoutes);
		}
	},
	methods: {
		...mapActions('manager', ['getAccountList', 'createManager', 'deleteAccount', 'updateAccount']),
		mapRouteListOptions(list) {
			return list
				.filter(route => route.roles.indexOf(this.ruleForm.role) > -1)
				.map(route => _.pick(route, ['label', 'value']));
		},
		mapRole(role) {
			return this.roleList.find(o => o.value == role).label;
		},
		resetForm() {
			this.$refs['ruleForm'].clearValidate();
			this.ruleForm = fields();
		},
		openDialog(data) {
			this.ruleForm = data || fields();
			this.isNewAccount = data ? false : true;
			this.dialogVisible = true;
		},
		closeDialog() {
			this.resetForm();
			this.dialogVisible = false;
		},
		validator(callback) {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					try {
						callback();
						this.closeDialog();
					} catch (e) {
						this.$message.error(e);
					}
				}
			});
		},
		handleChangeRole() {
			this.ruleForm.official_routes = [];
			this.ruleForm.challenge_routes = [];
		},
		handleNew() {
			this.validator(async () => {
				await this.createManager(this.ruleForm);
				this.$message({ type: 'success', message: '新增成功！' });
			});
		},
		handleUpdate() {
			this.validator(async () => {
				console.log(this.ruleForm);
				await this.updateAccount(this.ruleForm);
				this.$message({ type: 'success', message: '更新成功！' });
			});
		},
		handleDelete(id) {
			this.$confirm('確定刪除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.deleteAccount(id);
				this.$message({
					type: 'success',
					message: '删除成功！'
				});
			}).catch(() => { });
		}
	},
	async created() {
		await this.getAccountList();
	}
};
</script>

<style lang="scss">
.permission-manage {
	.el-dialog {
		max-width: 700px;

		.el-checkbox {
			width: 150px;
			margin-left: 0px;
			margin-right: 30px;
		}

		.el-input {
			width: 300px;
		}
	}
}
</style>